<div class="edit-class" style="overflow: auto; padding: 1rem 2rem">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="close(true)"
      data-dismiss="modal"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div (click)="close(true)">
    <p class="create-class-heading" style="font-size: 24px; padding: 20px">
      <a [routerLink]="['/session']"
        >Please sign in / sign up with this link to start the seminar</a
      >
    </p>
  </div>
</div>
